import '@/scss/app.scss';
// Added for locales we support contractually
import 'dayjs/locale/en-gb';
import 'dayjs/locale/ar-sa';

import * as Sentry from '@sentry/vue';

import { setupHttp } from '@/common/services/httpSetup';

import App from '@/App.vue';
// Services
import VTooltipPlugin from 'v-tooltip';
import Vue from 'vue';
import GlobalEvents from 'vue-global-events';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { initiateHeap } from '@/common/services/heapTracking';
import { setupLocalisation } from '@/common/services/i18n';
import isBetween from 'dayjs/plugin/isBetween';
import localeDataDaysJs from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import router from '@/common/router';
import store from '@/common/store';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(localeDataDaysJs);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);

Vue.use(VTooltipPlugin, {
  defaultTrigger: 'hover focus click'
});
// Load global vue components
Vue.component('GlobalEvents', GlobalEvents);

// Import Filters
require('@/common/helpers/filters');

Sentry.init({
  Vue: Vue,
  dsn: 'https://6fe2723ca3a596bdae2cd1b84e944f43@us.sentry.io/4506699910021120',
  logErrors: true,
  environment: process.env.VUE_APP_DEPLOY_ENV,
  integrations: [],
  beforeSend(event) {
    // Discard events from local environment (samknows-local or app-local when embedded) as per https://docs.sentry.io/platforms/javascript/configuration/filtering/#using--1
    if (event.request.url.match(/.*-local\.thousandeyes\.com.*/)) {
      return null;
    }
    return event;
  }
});

initiateHeap();
setupHttp();

// Initiate App Vue instance
new Vue({
  components: {
    App
  },
  render: (h) => h('app'),
  store,
  router,
  i18n: setupLocalisation()
}).$mount('#app');

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

window.jsBundleLoaded = true;

// in case the bundle took a long time to download
document.getElementById('bundle-fail-warn').style.display = 'none';
